import {AIAssetType} from 'common/src/modules/Assets/Assets.enums';
import {TemplateAssetType} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';

/**
 * Converts AICreativeAssetType to TemplateAssetType
 * @param aiAssetType - The AICreativeAssetType enum value
 * @returns The corresponding TemplateAssetType enum value
 */
export default function mapAICreativeAssetTypeToTemplateAssetType(aiAssetType: AIAssetType): TemplateAssetType {
  switch (aiAssetType) {
    case AIAssetType.Image:
      return TemplateAssetType.Image;
    case AIAssetType.Video:
      return TemplateAssetType.Video;
    case AIAssetType.Font:
      return TemplateAssetType.Font;
    default:
      throw new Error(`Unsupported AICreativeAssetType: ${aiAssetType}`);
  }
}
